import TreatmentPage from "./TreatmentPage";

export default function NailDiseasesTreatment() {
  return (
    <TreatmentPage
      title="Nail Diseases & Treatment"
      heroImage="/Treatment/Nail-Diseases-Treatment-drtruptis-clinic.png"

      intro="Nail diseases affect the health, appearance, and strength of fingernails and toenails. Common nail problems include fungal infections, ingrown nails, nail discoloration, thickened nails, brittle nails, and nail deformities. Proper diagnosis and timely treatment help restore healthy nail growth and prevent further complications."

      description="Nail disorders can occur due to fungal or bacterial infections, trauma, poor nail hygiene, tight footwear, or certain medical conditions. Professional treatment helps eliminate infection, reduce pain or discomfort, and improve the overall appearance of the nails."

      howItWorks="The treatment begins with a thorough examination of the affected nail to identify the underlying cause. Depending on the condition, treatment may include antifungal medications, medicated creams, nail cleaning procedures, or specialized dermatological therapies to control infection and support healthy nail regrowth."

      benefits={[
        "Treats fungal nail infections effectively.",
        "Reduces nail discoloration and thickening.",
        "Relieves pain caused by ingrown nails.",
        "Improves nail strength and appearance.",
        "Promotes healthy nail growth.",
        "Prevents further nail infections and damage."
      ]}

      beforeAfterImages={[
        "/Treatment/before-nail-disease-treatment.jpg",
        "/Treatment/after-nail-disease-treatment.jpg",
      ]}

      faqs={[
        { q: "What are common nail diseases?", a: "Common nail diseases include fungal nail infections, ingrown nails, nail discoloration, brittle nails, and thickened nails." },
        { q: "Are nail fungal infections contagious?", a: "Yes, fungal infections can spread through shared surfaces, footwear, or poor nail hygiene." },
        { q: "How long does nail treatment take?", a: "Treatment duration varies depending on the severity of the condition. Nail regrowth may take several weeks to months." },
        { q: "How can nail diseases be prevented?", a: "Maintaining good nail hygiene, keeping nails dry, avoiding tight footwear, and not sharing nail tools can help prevent nail problems." }
      ]}
    />
  );
}